/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const updateKYCHolderDetailConfig = {
  FIELDS: [
    {
      type: 'radio',
      compProps: {
        id: 'kyc_status',
        label: 'Know Your Customer (KYC) Status',
        required: true,
        errorText: 'Know Your Customer (KYC) Status is required',
        direction: 'horizontal',
        options: [
          {
            id: 'approve',
            label: 'Approve',
          },
          { id: 'reject', label: 'Reject' },
        ],
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'comments',
        label: 'Comments',
        required: true,
        placeholder: 'Enter your Comments',
        errorText: 'Comments is required',
      },
    },
  ],
  layout: [['kyc_status']],
  dynamicLayout: {
    kyc_status: {
      reject: [['comments']],
    },
  },
};
